import { initializeApp } from "firebase/app";

export const BRAND_NAME = "Booking Beauty Admin"; // Brand Name
export const DOMAIN_WEBSITE = "https://professionail.co.nz"; // Hosting Domain
export const DEFAULT_LANGUAGE = "en"; // Default Language
export const MASTER_EMAIL = "system_account_do_not_delete@professionail.co.nz";
export const SANDBOX = false;

export const firebaseConfig = {
  apiKey: "AIzaSyBsZzcl3UyFkdeMqwMQJpnjLiar2b2-Dx4",
  authDomain: "booking-beauty-system.firebaseapp.com",
  projectId: "booking-beauty-system",
  storageBucket: "booking-beauty-system.appspot.com",
  messagingSenderId: "68107423274",
  appId: "1:68107423274:web:fd3d8caa490050b7ba7d53",
  measurementId: "G-0TS7X255BY",
};

export const MAP_API_KEY = "AIzaSyDcXGeeGSGc65mu3TFRNGXyDiMpdPeExJY";
export const reCAPTCHA = "6LfnZQ8lAAAAAAYgRpNvkpLMgPfDffzxHXm7x78M";
export const STRIPE = {
  FILE: "rk_test_51FMSg5ACyf7z4ef6qFevc6NB6feHcE3Pp4cdrcdxKFHKdHR1TYdE0IuvQqHT3k5glIaUTHSNEVSeGNapVFgm6xTk00SDEDKUlI",
};

export const app = initializeApp(firebaseConfig);
// ========================= App String ========================= //

export const MEDIA_STORAGE =
  "https://storage.googleapis.com/" + firebaseConfig.storageBucket + "/";
